/*
 * File: IconButton.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:31 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import * as S from './IconButton.styles';


/**
 * Component
 */

export const IconButton = forwardRef(({
	size, icon, className, type, ...rest
}, ref) => (
	<S.Button ref={ref} size={size} type={type} className={className ? `${className} animate` : 'animate'} {...rest}>
		<FontAwesomeIcon icon={icon} />
	</S.Button>
));


/**
 * Configuration
 */

IconButton.displayName = 'IconButton';
IconButton.propTypes = {
	size: PropTypes.number,
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
	className: PropTypes.string,
	type: PropTypes.string
};
IconButton.defaultProps = {
	size: 1.75,
	className: null,
	type: 'button'
};
